import React from 'react';
import PropTypes from 'prop-types';
import IconCar from '@spothero/icons/car';
import IconCoveredSpot from '@spothero/icons/covered-spot';
import IconCurbsideDropoff from '@spothero/icons/curbside-dropoff';
import IconMarker from '@spothero/icons/marker';
import IconPublicTransit from '@spothero/icons/public-transit';
import IconShuttle from '@spothero/icons/shuttle';
import IconUncoveredSpot from '@spothero/icons/uncovered-spot';

const DEFAULT = 'default';
const TAXI = 'taxi';
const CURBSIDE_VALET = 'curbside-valet';
const ON_DEMAND = 'on-demand';
const PUBLIC_TRANSIT = 'public-transit';
const SHUTTLE_CONFIG = {
    [DEFAULT]: {
        shuttleIcon: IconShuttle,
        serviceDescription: 'Free shuttle',
        displayDuration: true,
    },
    [TAXI]: {
        shuttleIcon: IconCar,
        serviceDescription: 'Taxi/Rideshare',
        displayDuration: false,
    },
    [CURBSIDE_VALET]: {
        shuttleIcon: IconCurbsideDropoff,
        serviceDescription: 'Curbside dropoff',
        displayDuration: false,
    },
    [ON_DEMAND]: {
        shuttleIcon: IconShuttle,
        serviceDescription: 'Free shuttle on demand',
        displayDuration: false,
    },
    [PUBLIC_TRANSIT]: {
        shuttleIcon: IconPublicTransit,
        serviceDescription: 'Public transit accessible',
        displayDuration: false,
    },
};

const AirportSpotSummary = ({
    data: {
        details: {code, spot_type: spotType} = {},
        shuttle: {
            fast_frequency: shuttleMin,
            slow_frequency: shuttleMax,
            type: shuttleType,
        } = {},
    } = {},
    amenities,
    distanceInMiles,
}) => {
    const {displayDuration, serviceDescription, shuttleIcon} = {
        ...SHUTTLE_CONFIG[DEFAULT],
        ...SHUTTLE_CONFIG[shuttleType],
    };
    const shuttleSpan =
        shuttleMin && shuttleMax
            ? `${shuttleMin} - ${shuttleMax}`
            : shuttleMin || shuttleMax || '';
    const shuttleSpanDescription = shuttleSpan && `every ${shuttleSpan} min`;
    const isSelfPark = amenities.find(item => item.slug === 'self-park');
    const isValetPark = amenities.find(item => item.slug === 'valet');
    const Icon = shuttleIcon;

    return (
        <div className="AirportSpotSummary">
            {shuttleType !== TAXI && (
                <div className="AirportSpotSummary-item">
                    <Icon />
                    <span className="AirportSpotSummary-description">
                        {serviceDescription}{' '}
                        {displayDuration ? shuttleSpanDescription : ''}
                    </span>
                </div>
            )}
            <div className="AirportSpotSummary-item">
                <IconMarker />
                <span className="AirportSpotSummary-description">
                    {Number(distanceInMiles).toFixed(1)} miles to {code}
                </span>
            </div>
            <div className="AirportSpotSummary-item">
                {spotType === 'Covered' ? (
                    <IconCoveredSpot />
                ) : (
                    <IconUncoveredSpot />
                )}
                <span className="AirportSpotSummary-description">
                    {spotType} {isSelfPark ? 'self park' : ''}{' '}
                    {isValetPark ? 'valet' : ''}
                </span>
            </div>
        </div>
    );
};

AirportSpotSummary.propTypes = {
    data: PropTypes.object.isRequired,
    amenities: PropTypes.array.isRequired,
    distanceInMiles: PropTypes.number,
};

export default AirportSpotSummary;
